var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Menu ocultos")]),_c('v-card-subtitle',[_vm._v("Seleccionar los elementos que se desean ocultar del menu")]),_c('v-card-text',[_c('hide-menus',{on:{"input":_vm.updateSetting},model:{value:(_vm.hideMenus),callback:function ($$v) {_vm.hideMenus=$$v},expression:"hideMenus"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }